export enum DefaultFieldNames {
  NameField = 'Name',
  EmailAddressField = 'Email Address',
  PhoneField = 'Phone Number',
  CommentField = 'Comments'
}
